import { render, staticRenderFns } from "./CMAI.vue?vue&type=template&id=a2c4794e&scoped=true&"
import script from "./CMAI.vue?vue&type=script&lang=js&"
export * from "./CMAI.vue?vue&type=script&lang=js&"
import style0 from "./CMAI.vue?vue&type=style&index=0&id=a2c4794e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c4794e",
  null
  
)

export default component.exports